export const APP_ROUTES = {
  home: "/",
  kyc: "/kyc",
  cardManagement: "/card-management",
  cards: "/cards",
  cardOrder: "/cards/order",
  wallet: "/wallet",
  walletTransactions: "/wallet/transactions",
  securitySettings: "/security-settings",
  profile: "/profile",
  invite: "/invite",
  inviteStatistics: "/invite/statistics",
};

export const ERROR_ROUTES = {
  lockScreen: "/page-lock-screen/",
  error400: "/page-error-400",
  error403: "/page-error-403",
  error404: "/page-error-404",
  error500: "/page-error-500",
  error503: "/page-error-503",
};
